import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=41db5f28&scoped=true&lang=pug&"
import script from "./SidebarMobile.vue?vue&type=script&lang=js&"
export * from "./SidebarMobile.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMobile.vue?vue&type=style&index=0&id=41db5f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db5f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
